import { replace } from 'lodash';
import numeral from 'numeral';
import 'numeral/locales/pt-br';

// ----------------------------------------------------------------------

export function fCurrency(number) {
  if (parseInt(number, 2) < 1) return 0;
  const raw = number ? number.toString().replaceAll('.', '') : 0;

  let formatted = '';

  /* eslint no-plusplus: ["error", { "allowForLoopAfterthoughts": true }] */
  for (let i = raw.length; i > 0; i--) {
    if ((i - 1) % 3 === 0) {
      formatted = formatted.concat(`${raw[raw.length - i]}.`);
    } else {
      formatted = formatted.concat(raw[raw.length - i]);
    }
  }

  formatted = formatted.slice(0, -1);

  return formatted;
}

export function fPercent(number) {
  return numeral(number / 100).format('0.0%');
}

export function fNumber(number) {
  return numeral(number).format();
}

export function fShortenNumber(number) {
  return replace(numeral(number).format('0.00a'), '.00', '');
}

export function fData(number) {
  return numeral(number).format('0.0 b');
}
